import { graphql } from "~/gql";

export const FILTER_USERS_QUERY = graphql(/* GraphQL */ `
  query FilterUsers(
    $includeLoggedInUserFirst: Boolean
    $filter: UserFilterInput!
    $offset: Int
    $limit: Int
    $restrictedExternalMatterId: Int
    $restrictedClientId: Int
  ) {
    filterUsers(
      includeLoggedInUserFirst: $includeLoggedInUserFirst
      filter: $filter
      offset: $offset
      limit: $limit
      restrictedExternalMatterId: $restrictedExternalMatterId
      restrictedClientId: $restrictedClientId
    ) {
      count
      users {
        id
        displayName
        userName
      }
    }
  }
`);
